module.exports = __webpack_public_path__ + "img/banner3.686dfad8.jpg";